export const GET_RACKS = 'GET_RACKS';
export const GET_RACKS_SUCCESS = 'GET_RACKS_SUCCESS';
export const GET_RACKS_ERROR = 'GET_RACKS_ERROR';
